type Props = {
  children: JSX.Element | JSX.Element[];
};

const PopoutContainer = ({ children }: Props) => {
  return <div className="rounded-lg bg-concrete p-4">{children}</div>;
};

export default PopoutContainer;
